const NUMERIC = /^-?\d+(\.\d+)?$/;

// A leading = + - @ makes spreadsheets evaluate the cell as a formula; numbers are exempt so negative amounts stay numeric.
const cell = (v: any) => {
  let s = v === null || v === undefined ? "" : String(v);
  if (!NUMERIC.test(s) && /^\s*[=+\-@]|^[\t\r\n]/.test(s)) s = `'${s}`;
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const downloadCsv = (filename: string, cols: string[], rows: Record<string, any>[]) => {
  const csv = [cols.join(","), ...rows.map((r) => cols.map((c) => cell(r[c])).join(","))].join("\n");
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8;" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 0);
};
